<ng-container *ngIf="(labelList && labelList.length>0) && DP_TEMPLATES_ENABLED">
  <div *ngFor="let item of labelList" class="c-dp-search__template-block">
    <div class="c-dp-search__template-item" (click)="selectItem(item)">
      <ng-container *ngFor="let combinationItem of item?.combinationArray">
        <ng-container *ngIf="!combinationItem?.isReturnFlight">
          <svg class="a-icon" [ngClass]="{'c-dp-search__template-item-plus': combinationItem?.isPlusIcon}">
            <use [attr.xlink:href]="combinationItem?.icon"></use>
          </svg>
        </ng-container>
      </ng-container>
    </div>
    <span class="c-dp-search__template-lbl">{{item?.title}}</span>
  </div>

</ng-container>
